import axios from "axios";

export const createCustomer = async (customer) => {
    const response = await axios.post(`/api/customers`, { customer });
    return response.data;
};

export const updateCustomer = async customer => {
    const response = await axios.put(`/api/customers`, { customer });
    return response.data;
};

export const getCustomer = async id => {
    const response = await axios.get(`/api/customers/${id}`);
    return response.data;
};

export const getCustomerVehicles = async id => {
    const response = await axios.get(`/api/customer/vehicles/${id}`);
    return response.data;
};

export const deleteCustomer = async id => {
    const response = await axios.delete(`/api/customers/${id}`);
    return response.data;
};
